import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

const BLUE = "#0038A8";
const LIGHT_BLUE = "#e8edf8";

const s = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: "Helvetica",
    fontSize: 10,
    color: "#111827",
    backgroundColor: "#ffffff",
  },

  /* Header */
  header: {
    paddingBottom: 12,
    borderBottomWidth: 2,
    borderBottomColor: BLUE,
    marginBottom: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  brand: { fontSize: 18, fontFamily: "Helvetica-Bold", color: BLUE },
  brandSub: { fontSize: 8, color: "#9ca3af", marginTop: 2 },

  /* Title */
  title: { fontSize: 22, fontFamily: "Helvetica-Bold", marginBottom: 4 },
  fromText: { fontSize: 9, color: "#6b7280", marginBottom: 18 },

  /* Section */
  sectionHeading: {
    fontSize: 9,
    fontFamily: "Helvetica-Bold",
    color: BLUE,
    backgroundColor: LIGHT_BLUE,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
    marginTop: 14,
    marginBottom: 4,
  },

  /* Item row */
  itemRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 5,
    borderBottomWidth: 0.5,
    borderBottomColor: "#e5e7eb",
  },
  checkbox: {
    width: 10,
    height: 10,
    borderWidth: 0.75,
    borderColor: "#9ca3af",
    borderRadius: 2,
    marginRight: 10,
    flexShrink: 0,
  },
  itemName: { flex: 1, fontSize: 10 },
  itemQty: { fontSize: 10, color: "#6b7280", fontFamily: "Helvetica-Bold" },

  /* Summary */
  summary: {
    fontSize: 9,
    color: "#6b7280",
    marginBottom: 4,
  },

  /* Footer */
  footer: {
    position: "absolute",
    bottom: 28,
    left: 40,
    right: 40,
    textAlign: "center",
    fontSize: 8,
    color: "#9ca3af",
    paddingTop: 6,
    borderTopWidth: 0.5,
    borderTopColor: "#e5e7eb",
  },
});

export function GroceryPDFDocument({ grouped, recipeNames }) {
  const sections = Object.entries(grouped || {}).filter(([, items]) => items?.length);
  const totalItems = sections.reduce((sum, [, items]) => sum + items.length, 0);

  return (
    <Document title="Grocery List" author="Pamangan">
      <Page size="A4" style={s.page}>

        {/* Header */}
        <View style={s.header}>
          <View>
            <Text style={s.brand}>Pamangan</Text>
            <Text style={s.brandSub}>pamangan.com</Text>
          </View>
        </View>

        {/* Title */}
        <Text style={s.title}>Grocery List</Text>
        {recipeNames?.length > 0 && (
          <Text style={s.fromText}>From: {recipeNames.join(", ")}</Text>
        )}
        <Text style={s.summary}>{totalItems} items across {sections.length} categories</Text>

        {/* Sections */}
        {sections.map(([section, items]) => (
          <View key={section}>
            <Text style={s.sectionHeading}>{section}</Text>
            {items.map((item, i) => (
              <View key={i} style={s.itemRow}>
                <View style={s.checkbox} />
                <Text style={s.itemName}>{item.item}</Text>
                {item.quantity ? <Text style={s.itemQty}>{item.quantity}</Text> : null}
              </View>
            ))}
          </View>
        ))}

        {/* Footer */}
        <Text style={s.footer}>Generated by Pamangan — pamangan.com</Text>
      </Page>
    </Document>
  );
}
